import type { CategoryMeta } from "@/types/content";

export const categories: CategoryMeta[] = [
  {
    key: "film-news",
    path: "/category/film-news",
    name: "影视资讯",
    shortName: "影视资讯",
    description:
      "聚焦国内外影视行业前沿动态，涵盖开机杀青、定档上映、票房数据、幕后制作与产业观察，第一时间为你梳理值得关注的影视大事件。",
    icon: "ri-film-line",
  },
  {
    key: "entertainment-news",
    path: "/category/entertainment-news",
    name: "娱乐新闻",
    shortName: "娱乐新闻",
    description:
      "网罗华语与海外娱乐圈热点，明星动态、综艺资讯、红毯盛典与行业花絮一网打尽，轻松掌握每日娱乐风向。",
    icon: "ri-star-smile-line",
  },
  {
    key: "movie-recommend",
    path: "/category/movie-recommend",
    name: "电影推荐",
    shortName: "电影推荐",
    description:
      "按类型与年份精选优质影片，从商业大片到文艺佳作，帮你快速找到下一部值得花时间的好电影。",
    icon: "ri-movie-2-line",
  },
  {
    key: "tv-update",
    path: "/category/tv-update",
    name: "电视剧更新",
    shortName: "电视剧更新",
    description:
      "实时跟进热播剧集更新进度，国剧、美剧、韩剧、日剧一表掌握，再也不错过任何一次追更。",
    icon: "ri-tv-2-line",
  },
];

export const getCategoryMeta = (key: string): CategoryMeta | undefined =>
  categories.find((c) => c.key === key);